import api from './utilPartner';

const controller = 'AuditTrail';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  ComboEntidades: function () {
    return api.Axios.Get(url + '/ComboEntidades');
  }
});
